import React from "react";
import {ToastStore} from "../store";
import {ToastContext} from "../context";
import {ToastViewport} from "../components";

export const ToastProvider = ({ children, config }) => {
    const store = React.useMemo(() => new ToastStore(), []);

    // Apply configuration changes
    React.useEffect(() => {
        if (config) store.configure(config);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [config]);

    const toastApi = React.useMemo(() => ({
        // expose reactive props for viewport consumption
        get items() { return store.items; },
        get position() { return store.position; },

        // action methods
        success: (opts) => store.push({ variant: "success", ...opts }),
        info:    (opts) => store.push({ variant: "info", ...opts }),
        warning: (opts) => store.push({ variant: "warning", ...opts }),
        error:   (opts) => store.push({ variant: "error", ...opts }),
        clear:   () => store.clear(),
        close:   (id) => store.close(id),
        configure: (opts) => store.configure(opts),
        store,
    }), [store]);

    return (
        <ToastContext.Provider value={toastApi}>
            <ToastViewport />
            {children}
        </ToastContext.Provider>
    );
};